import React from 'react';
import styled, { css } from 'styled-components';
import { device } from '../../styles/template';

interface Props {
	children?: React.ReactNode;
	gap?: string;
	shrink?: boolean;
	stretch?: boolean;
	margin?: string;
	centeredContent?: boolean;
	centeredContentMobileOnly?: boolean;
	centeredText?: boolean;
	id?: string;
	className?: string;
	stretchAutoWidth?: boolean;
	wrap?: boolean;
	stretchMobileOnly?: boolean;
}

const Wrap = styled.div<Props>`
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    margin: ${({ margin }) => margin || '0'}rem 0;
    gap: ${({ gap }) => gap || '0'}rem;
  
    ${({ centeredContent }) => centeredContent && css`
        justify-content: center;
    `}

    ${({ centeredContentMobileOnly }) => centeredContentMobileOnly && css`
        justify-content: center;

        @media ${device.tablet} {
            justify-content: flex-start;
        }
    `}

    ${({ wrap }) => wrap && css`
    	flex-wrap: wrap;
    `}

    ${({ centeredText }) => centeredText && css`
        text-align: center;
    `}
    
    ${({ shrink }) => shrink && css`
        flex-shrink: 1;
    `}

    // элементы растягиваются, чтобы заполнить все пространство
    ${({ stretch }) => stretch && css`
        & > * {
            flex: 1 1 0; // Элементы растягиваются равномерно
            min-width: 0; // Предотвращение переполнения
        }
    `}

    ${({ stretchMobileOnly }) => stretchMobileOnly && css`
	        & > * {
	          flex: 1 1 0; 
	          min-width: 0; 
	        }
	    `}

    @media ${device.tablet} {
  		${({ stretchMobileOnly }) => stretchMobileOnly && css`
	        & > * {
              flex: unset;
              min-width: unset;
	        }
	    `}
    }
    

    ${({ stretchAutoWidth, gap }) => stretchAutoWidth && css`
		  justify-content: space-between; 
		  & > *:not(:last-child) {
		    margin-right: ${gap || '0'}rem;
		  }
		  & > *:last-child {
		    margin-left: auto; 
		  }
    `}
`;

const FlexContainer: React.FC<Props> = props => {
	const { children, ...restProps } = props;
	return <Wrap {...restProps}>{children}</Wrap>;
}

export default FlexContainer;
